// Component imports
import { StaffCardForm } from "./StaffCardForm";
// Material-ui imports
import Grid from "@mui/material/Grid";

export const StaffCardAdd = () => {
  return (
    <Grid
      container
      columns={4}
      sx={{
        justifyContent: "center",

        pt: {
          xs: 2,
          md: 3,
        },
      }}
    >
      <Grid
        size={{
          xs: 4,
          md: 2,
        }}
      >
        <StaffCardForm newStaff />
      </Grid>
    </Grid>
  );
};
